/* eslint-env jest */
import { mapWorkSetup } from './workSetupMap';

test('maps work-setup strings to numeric codes', () => {
  expect(mapWorkSetup('WFH')).toBe(2);
  expect(mapWorkSetup('Deployed')).toBe(3);
  expect(mapWorkSetup('Onsite')).toBe(1);
});
